/**
 * Extract a YouTube video id from common URL formats.
 */
export function parseYoutubeVideoId(url) {
  if (!url || typeof url !== "string") return null;

  const trimmed = url.trim();
  if (!trimmed) return null;

  const patterns = [
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /^([a-zA-Z0-9_-]{11})$/,
  ];

  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match?.[1]) return match[1];
  }

  return null;
}

export function toYoutubeEmbedUrl(url) {
  const id = parseYoutubeVideoId(url);
  if (!id) return "";
  return `https://www.youtube.com/embed/${id}`;
}

export function hasValidYoutubeShorts(url) {
  return Boolean(parseYoutubeVideoId(url));
}
